import { getMaster, delMaster } from "utils/api";

export const getRoleList = async (params) => {
  return await getMaster("/roles", {
    sort: "created_date,desc",
    ...params,
  });
};

export const updateStatus = async (params) => {
  return await putOperation("/agent", {
    ...params,
  });
};

export const deleteRole = async (roleId) => {
  return await delMaster("/roles/" + roleId, {});
};
